import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { SavedQueryOverviewContainerComponent } from './saved-query-overview-container/saved-query-overview-container.component';

const routes: Route[] = [
    {
        path: '',
        component: SavedQueryOverviewContainerComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SavedQueriesOverviewRoutingModule {}
